import Factory from '../di/factory';


class PageLoaderFactory extends Factory {

	constructor({container, prefix = '', suffix = 'PageLoader'}) {
		super({container: container, prefix: prefix, suffix: suffix});
    }

}


export default PageLoaderFactory;
